import { Switch, Route, useLocation, useHistory } from "react-router-dom";
import { useEffect, useState, useLayoutEffect, useContext } from "react";
import { useCookies } from "react-cookie";

//Componenti
import Breadcrumb from "./Breadcrumb";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "design-react-kit";

//Pagine Operatore
import ListRanges from "../Page/Operator/ListRanges";
import Home from "../Page/Operator/Home";
import ListISEEUploaded from "../Page/Operator/ListISEEUploaded";
import ListISEEValidated from "../Page/Operator/ListISEEValidated";
import ListAnnouncements from "../Page/Operator/ListAnnouncements";
import ListFlows from "../Page/Operator/ListFlows";
import ListPayments from "../Page/Operator/ListPayments";
import CheckISEE from "../Page/Operator/CheckISEE";
import CheckRefound from "../Page/Operator/CheckRefound";
import ViewISEE from "../Page/Operator/ViewISEE";
import EditRange from "../Page/Operator/EditRange";
import UploadISEEOperator from "../Page/Operator/UploadISEE";
import NewRange from "../Page/Operator/NewRange";
import ListUsers from "../Page/Operator/ListUsers";
import ListExecutive from "../Page/Operator/ListExecutive";
import ListServices from "../Page/Operator/ListServices";
import NewExecutive from "../Page/Operator/NewExecutive";
import NewService from "../Page/Operator/NewService";
import NewUser from "../Page/Operator/NewUser";
import EditUser from "../Page/Operator/EditUser";
import EditService from "../Page/Operator/EditService";
import AddAssistito from "../Page/Operator/AddAssistito";
import ListPresenze from "../Page/Operator/ListPresenze";
import ViewExecutive from "../Page/Operator/ViewExecutive";
import ViewCartellaSociale from "../Page/Operator/ViewCartellaSociale";
import ViewBudget from "../Page/Operator/ViewBudget";
import ShowSubscriptionGeneralStatus from "../Page/Operator/ShowSubscriptionGeneralStatus";
import ShowFileGeneralStatus from "../Page/Operator/ShowFileGeneralStatus";
import ListRendicontazione from "../Page/Operator/ListRendicontazione";
import EditFondo from "../Page/Operator/EditFondo";
import ListPaymemtsStatus from "../Page/Operator/ListPaymentsStatus";

//Pagine Delegato
import HomeDelegate from "../Page/Delegate/HomeDelegate";

//Pagine utente
import HomeUser from "../Page/User/HomeUser";
import UploadISEE from "../Page/User/UploadISEE";
import UploadReceipt from "../Page/User/UploadReceipt";
import ListAnnouncementsServices from "../Page/User/ListAnnouncementsServices";
import UserProfile from "../Page/User/UserProfile";
import NewAnnouncement from "../Page/Operator/NewAnnouncement";
import EditAnnouncement from "../Page/Operator/EditAnnouncement";
import AnnouncementDetail from "../Page/Operator/AnnouncementDetail";
import SubscriptionDetail from "../Page/Operator/SubscriptionDetail";
import ViewAnnouncements from "../Page/User/ViewAnnouncements";
import Help from "../Page/User/Help";
import ListPaymemts from "../Page/Operator/ListPayments";
import jwt_decode from "jwt-decode";

//Slogged
import HomeNoLogin from "../Page/NoLogin/Home";
import Subscription from "../Page/User/Subscription";
import Configuration from "../Page/Operator/Configuration";
import ViewAnnouncementsNoLogin from "../Page/NoLogin/ViewAnnouncements";

//Common
import PrivacyPolicy from "../Page/Common/PrivacyPolicy";

//Context
import { TokenContext } from "../Components/TokenContext";
import ListCoupons from "../Page/Operator/ListCoupons";
import AggiornamentoMassivo from "../Page/Operator/AggiornamentoMassivo";

//Attività
import HomeExecutive from "../Page/Executive/HomeExecutive";
import ProfileExecutive from "../Page/Executive/ProfileExecutive";
import ListExecutiveCoupon from "../Page/Executive/ListExecutiveCoupon";
import ViewQCode from "../Page/Executive/ViewQCode";
import ViewAlunniMensa from "../Page/Operator/ViewAlunniMensa";
import ResponsabiliMenuOp from "../Page/Operator/ResponsabiliMenuOp";
import StatistichePage from "../Page/Operator/StatistichePage";
import ChatbotPage from "../Page/Operator/ChatbotPage";

function Body(props) {
  const [cookies] = useCookies();
  const apiToken = useContext(TokenContext);

  const [isAttivita, setisAttivita] = useState(false);
  const [comuneDelegate, setComuneDelegate] = useState(false);
  const [isOperator, setIsOperator] = useState(false);
  const [isDelegate, setIsDelegate] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isCitizen, setIsCitizen] = useState(false);
  const [isNoAutorize, setIsNoAutorize] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [codiceFiscale, setCodiceFiscale] = useState("");
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (cookies.user_profile) {
      if (cookies.user_profile.WorkingEntityId) {
        setIsOperator(true);
      } else {
        setCodiceFiscale(cookies.user_profile.FiscalCode);
      }
    }
    if (codiceFiscale) {
      setCodiceFiscale(cookies.user_profile.FiscalCode);
    }

    var decoded = {};
    if (apiToken !== undefined) {
      decoded = jwt_decode(apiToken);
      if (decoded.role.includes("CITIZEN")) {
        setIsCitizen(true);
      }
      if (decoded.role.includes("OPERATOR")) {
        setIsOperator(true);
        if (decoded.role.includes("USER")) {
          setIsOperator(false);
          setIsUser(true);
        } else if (
          decoded.role.includes("EXECUTIVE") &&
          !decoded.role.includes("DELEGATE")
        ) {
          setisAttivita(true);
          setIsOperator(false);
          setIsDelegate(false);
        } else if (
          !decoded.role.includes("EXECUTIVE") &&
          decoded.role.includes("DELEGATE")
        ) {
          setisAttivita(false);
          setIsOperator(false);
          setIsDelegate(true);
          setComuneDelegate(prettifyAmbito(decoded.ClientIds));
        } else if (
          decoded.role.includes("EXECUTIVE") &&
          decoded.role.includes("DELEGATE")
        ) {
          setisAttivita(false);
          setIsOperator(false);
          setIsDelegate(true);
          setComuneDelegate(prettifyAmbito(decoded.ClientIds));
        }
      } else {
        setIsNoAutorize(true);
        setisAttivita(false);
        setIsOperator(false);
        setIsDelegate(false);
      }
    }
  }, [cookies]);

  useEffect(() => {
    if (isCitizen && process.env.REACT_APP_URL_ISTANZE) {
      window.location.replace(process.env.REACT_APP_URL_ISTANZE);
    }
  }, [isCitizen]);

  function prettifyAmbito(slug) {
    if (slug)
      return slug
        .replace(/^ambito_/, "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
    else return false;
  }

  function PageNotFound() {
    const history = useHistory();
    return (
      <div className="container">
        <div className="row">
          <h1>Autorizzazione negata</h1>

          <div className="clearfix col-12">
            <p>Non sei autorizzato a visualizzare questa pagina.</p>

            <button
              className="btn btn-secondary"
              type="button"
              onClick={() => history.goBack()}
            >
              {" "}
              Indietro{" "}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <main role="main" className="main-body">
      {apiToken ? (
        <>
          {isNoAutorize && (
            <>
              <div className="container mb-5 mt-3">
                <Switch>
                  <Route path="*">
                    <PageNotFound />
                  </Route>
                </Switch>
              </div>
            </>
          )}

          {isDelegate && (
            <Switch>
              <Route
                exact
                path={[
                  "/visualizza_isee",
                  "/lista_utenti/cartella_sociale/visualizza_isee",
                ]}
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ViewISEE subfolder={props.subfolder}></ViewISEE>
                </div>
              </Route>
              <Route exact path="/lista_utenti">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListUsers
                    subfolder={props.subfolder}
                    isDelegate={true}
                    comuneDelegate={comuneDelegate}
                  ></ListUsers>
                </div>
              </Route>
              <Route exact path="/iscrizioni">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ShowSubscriptionGeneralStatus
                    subfolder={props.subfolder}
                    apiToken={apiToken}
                  ></ShowSubscriptionGeneralStatus>
                </div>
              </Route>

              <Route exact path="/lista_utenti/nuovo_utente">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <NewUser
                    subfolder={props.subfolder}
                    comuneDelegate={comuneDelegate}
                  ></NewUser>
                </div>
              </Route>
              <Route exact path="/lista_utenti/dati_utente">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <EditUser subfolder={props.subfolder}></EditUser>
                </div>
              </Route>

              <Route
                exact
                path={[
                  "/lista_interventi/dettaglio_intervento/lista_pagamenti",
                ]}
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListPayments subfolder={props.subfolder}></ListPayments>
                </div>
              </Route>

              <Route exact path="/lista_utenti/cartella_sociale">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb title="Dettaglio"></Breadcrumb>
                  <ViewCartellaSociale
                    subfolder={props.subfolder}
                  ></ViewCartellaSociale>
                </div>
              </Route>
              <Route
                exact
                path="/lista_utenti/cartella_sociale/dettagli_iscrizione"
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb title="Dettaglio"></Breadcrumb>
                  <SubscriptionDetail
                    subfolder={props.subfolder}
                    isDelegate={true}
                  ></SubscriptionDetail>
                </div>
              </Route>

              <Route exact path="/lista_interventi">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListAnnouncements
                    isDelegate={true}
                    subfolder={props.subfolder}
                  ></ListAnnouncements>
                </div>
              </Route>
              <Route
                exact
                path={[
                  "/lista_interventi/dettaglio_intervento",
                  "/categorie/visualizza_categoria/dettaglio_intervento",
                ]}
              >
                <div className="container shadow-sm p-3 bg-white">
                  <Breadcrumb></Breadcrumb>
                </div>
                <AnnouncementDetail
                  subfolder={props.subfolder}
                  isDelegate={true}
                ></AnnouncementDetail>
              </Route>
              <Route
                exact
                path={[
                  "/caricamento_ISEE_operatore",
                  "/lista_utenti/cartella_sociale/caricamento_ISEE_operatore",
                ]}
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <UploadISEEOperator
                    subfolder={props.subfolder}
                  ></UploadISEEOperator>
                </div>
              </Route>

              <Route exact path="/pagamenti">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListPaymemtsStatus
                    subfolder={props.subfolder}
                  ></ListPaymemtsStatus>
                </div>
              </Route>
              <Route path="*">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <HomeDelegate
                    userDataStatus={props.userDataStatus}
                    subfolder={props.subfolder}
                  ></HomeDelegate>
                </div>
              </Route>
            </Switch>
          )}

          {isUser && (
            <Switch>
              <Route path="*">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ViewAlunniMensa
                    subfolder={props.subfolder}
                    isUser={true}
                  ></ViewAlunniMensa>
                </div>
              </Route>
            </Switch>
          )}

          {/*     Pagine Utente  */}
          {isCitizen && !isNoAutorize && (
            <div className="container mb-5 mt-3 shadow-sm p-3 mb-5 bg-white rounded">
              <Switch>
                <Route exact path="/iscrizioni">
                  <Breadcrumb></Breadcrumb>
                  <Subscription subfolder={props.subfolder}></Subscription>
                </Route>
                <Route exact path="/caricamento_ISEE">
                  <Breadcrumb></Breadcrumb>
                  <UploadISEE subfolder={props.subfolder}></UploadISEE>
                </Route>
                <Route exact path="/caricamento_receipt">
                  <Breadcrumb></Breadcrumb>
                  <UploadReceipt subfolder={props.subfolder}></UploadReceipt>
                </Route>
                <Route exact path="/intervento_categoria">
                  <Breadcrumb></Breadcrumb>
                  <ListAnnouncementsServices
                    subfolder={props.subfolder}
                  ></ListAnnouncementsServices>
                </Route>
                <Route
                  exact
                  path={[
                    "/intervento_categoria/visualizza_categoria",
                    "/iscrizioni/visualizza_categoria",
                  ]}
                >
                  <Breadcrumb></Breadcrumb>
                  <ViewAnnouncements
                    subfolder={props.subfolder}
                  ></ViewAnnouncements>
                </Route>
                <Route exact path="/profilo">
                  <Breadcrumb></Breadcrumb>
                  <UserProfile subfolder={props.subfolder}></UserProfile>
                </Route>
                <Route path="/privacy_policy">
                  <Breadcrumb></Breadcrumb>
                  <PrivacyPolicy subfolder={props.subfolder}></PrivacyPolicy>
                </Route>
                <Route path="/supporto">
                  <Breadcrumb></Breadcrumb>
                  <Help subfolder={props.subfolder}></Help>
                </Route>
                <Route path="/home">
                  <HomeUser
                    userDataStatus={props.userDataStatus}
                    subfolder={props.subfolder}
                  ></HomeUser>
                </Route>
                <Route path="*"></Route>
              </Switch>
            </div>
          )}
          {/* Pagine Operatore  */}

          {isOperator && (
            <Switch>
              <Route path="/calendario/gestione_responsabili">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ResponsabiliMenuOp
                    subfolder={props.subfolder}
                    isOperator={true}
                    apiToken={apiToken}
                  ></ResponsabiliMenuOp>
                </div>
              </Route>
              <Route path="/calendario">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ViewAlunniMensa
                    subfolder={props.subfolder}
                    isOperator={true}
                  ></ViewAlunniMensa>
                </div>
              </Route>
              <Route path="/supporto">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <Help subfolder={props.subfolder}></Help>
                </div>
              </Route>
              <Route exact path="/lista_utenti">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListUsers subfolder={props.subfolder}></ListUsers>
                </div>
              </Route>
              <Route exact path="/lista_utenti/nuovo_utente">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <NewUser subfolder={props.subfolder}></NewUser>
                </div>
              </Route>
              <Route exact path="/lista_utenti/dati_utente">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <EditUser subfolder={props.subfolder}></EditUser>
                </div>
              </Route>
              <Route
                exact
                path={[
                  "/caricamento_ISEE_operatore",
                  "/lista_utenti/cartella_sociale/caricamento_ISEE_operatore",
                ]}
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <UploadISEEOperator
                    subfolder={props.subfolder}
                  ></UploadISEEOperator>
                </div>
              </Route>
              <Route exact path="/lista_utenti/cartella_sociale">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb title="Dettaglio"></Breadcrumb>
                  <ViewCartellaSociale
                    subfolder={props.subfolder}
                  ></ViewCartellaSociale>
                </div>
              </Route>

              <Route exact path="/pagamenti">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListPaymemtsStatus
                    subfolder={props.subfolder}
                  ></ListPaymemtsStatus>
                </div>
              </Route>

              <Route exact path="/rendicontazione">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb title="Rendicontazione"></Breadcrumb>
                  <ListRendicontazione
                    subfolder={props.subfolder}
                  ></ListRendicontazione>
                </div>
              </Route>

              <Route exact path="/rendicontazione/modifica_fondo/:id">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <EditFondo subfolder={props.subfolder}></EditFondo>
                </div>
              </Route>
              <Route exact path="/rendicontazione/nuovo_fondo">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <EditFondo subfolder={props.subfolder}></EditFondo>
                </div>
              </Route>

              <Route
                exact
                path="/lista_utenti/cartella_sociale/dettagli_iscrizione"
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb title="Dettaglio"></Breadcrumb>
                  <SubscriptionDetail
                    subfolder={props.subfolder}
                    isOperator={true}
                  ></SubscriptionDetail>
                </div>
              </Route>

              <Route exact path="/lista_utenti/aggiungi-assistito">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <AddAssistito
                    subfolder={props.subfolder}
                    apiToken={apiToken}
                  />
                </div>
              </Route>

              <Route exact path="/esercenti/profilo_esercente">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ViewExecutive subfolder={props.subfolder}></ViewExecutive>
                </div>
              </Route>

              <Route exact path="/esercenti/nuovo_esercente">
                <Breadcrumb></Breadcrumb>
                <NewExecutive subfolder={props.subfolder}></NewExecutive>
              </Route>

              <Route exact path="/esercenti">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListExecutive subfolder={props.subfolder}></ListExecutive>
                </div>
              </Route>

              <Route exact path="/lista_interventi">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListAnnouncements
                    subfolder={props.subfolder}
                  ></ListAnnouncements>
                </div>
              </Route>
              <Route exact path="/fasce">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListRanges subfolder={props.subfolder}></ListRanges>
                </div>
              </Route>
              <Route exact path="/lista_isee">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListISEEUploaded
                    subfolder={props.subfolder}
                  ></ListISEEUploaded>
                </div>
              </Route>
              <Route
                exact
                path={[
                  "/lista_utenti/cartella_sociale/verifica_isee",
                  "/lista_isee/verifica_isee",
                ]}
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <CheckISEE subfolder={props.subfolder}></CheckISEE>
                </div>
              </Route>
              <Route
                exact
                path={[
                  "/visualizza_isee",
                  "/lista_utenti/cartella_sociale/visualizza_isee",
                ]}
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ViewISEE subfolder={props.subfolder}></ViewISEE>
                </div>
              </Route>
              <Route exact path="/iscrizioni">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ShowSubscriptionGeneralStatus
                    subfolder={props.subfolder}
                    apiToken={apiToken}
                  ></ShowSubscriptionGeneralStatus>
                </div>
              </Route>
              <Route exact path="/file_utenti">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb title="Rimborsi utenti"></Breadcrumb>
                  <ShowFileGeneralStatus
                    subfolder={props.subfolder}
                  ></ShowFileGeneralStatus>
                </div>
              </Route>

              <Route exact path="/visualizza_rimborso">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <CheckRefound subfolder={props.subfolder}></CheckRefound>
                </div>
              </Route>

              <Route exact path="/fasce/modifica_fascia">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <EditRange subfolder={props.subfolder}></EditRange>
                </div>
              </Route>
              <Route exact path="/fasce/nuova_fascia">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <NewRange subfolder={props.subfolder}></NewRange>
                </div>
              </Route>
              <Route exact path="/categorie">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListServices subfolder={props.subfolder}></ListServices>
                </div>
              </Route>
              <Route exact path="/categorie/nuova_categoria">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <NewService subfolder={props.subfolder}></NewService>
                </div>
              </Route>
              <Route exact path="/categorie/visualizza_categoria">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <EditService subfolder={props.subfolder}></EditService>
                </div>
              </Route>
              <Route
                exact
                path={[
                  "/lista_interventi/nuovo_intervento",
                  "/categorie/visualizza_categoria/nuovo_intervento",
                ]}
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <NewAnnouncement
                    subfolder={props.subfolder}
                  ></NewAnnouncement>
                </div>
              </Route>
              <Route
                exact
                path={
                  "/lista_interventi/dettaglio_intervento/modifica_intervento"
                }
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <EditAnnouncement
                    subfolder={props.subfolder}
                  ></EditAnnouncement>
                </div>
              </Route>
              <Route
                exact
                path={[
                  "/lista_interventi/dettaglio_intervento",
                  "/categorie/visualizza_categoria/dettaglio_intervento",
                ]}
              >
                <div className="container shadow-sm p-3 bg-white">
                  <Breadcrumb></Breadcrumb>
                </div>
                <AnnouncementDetail
                  subfolder={props.subfolder}
                  isOperator={true}
                ></AnnouncementDetail>
              </Route>
              <Route
                exact
                path={[
                  "/lista_interventi/dettaglio_intervento/lista_pagamenti",
                ]}
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListPayments subfolder={props.subfolder}></ListPayments>
                </div>
              </Route>
              <Route
                exact
                path="/lista_interventi/dettaglio_intervento/lista_presenze/:paramId"
              >
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListPresenze
                    subfolder={props.subfolder}
                    apiToken={apiToken}
                  ></ListPresenze>
                </div>
              </Route>

              <Route exact path={["/pagamenti"]}>
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListFlows subfolder={props.subfolder}></ListFlows>
                </div>
              </Route>
              <Route exact path="/buoni_servizio">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ListCoupons
                    subfolder={props.subfolder}
                    apiToken={apiToken}
                  />
                </div>
              </Route>

              <Route exact path="/budget">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <ViewBudget subfolder={props.subfolder}></ViewBudget>
                </div>
              </Route>

              <Route exact path="/statistiche">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <StatistichePage subfolder={props.subfolder} />
                </div>
              </Route>

              <Route exact path="/assistente_cf">
                <Breadcrumb></Breadcrumb>
                <ChatbotPage subfolder={props.subfolder} />
              </Route>

              <Route exact path={"/configurazione"}>
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <Configuration subfolder={props.subfolder}></Configuration>
                </div>
              </Route>

              <Route path="/aggiornamento_massivo">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <AggiornamentoMassivo
                    subfolder={props.subfolder}
                    isOperator={true}
                  ></AggiornamentoMassivo>
                </div>
              </Route>

              <Route path="/privacy_policy">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Breadcrumb></Breadcrumb>
                  <PrivacyPolicy subfolder={props.subfolder}></PrivacyPolicy>
                </div>
              </Route>

              <Route exact path="*">
                <div className="container shadow-sm p-3 mb-5 bg-white rounded">
                  <Home subfolder={props.subfolder}></Home>
                </div>
              </Route>
            </Switch>
          )}

          {isAttivita && (
            <Switch>
              <Route
                exact
                path={[
                  "/lista_interventi/dettaglio_intervento",
                  "/categorie/visualizza_categoria/dettaglio_intervento",
                ]}
              >
                <div className="container shadow-sm p-3 bg-white">
                  <Breadcrumb></Breadcrumb>
                </div>
                <AnnouncementDetail
                  subfolder={props.subfolder}
                  isExecutive={true}
                ></AnnouncementDetail>
              </Route>
              <Route exact path="/lista_utenti">
                <div className="container shadow-sm p-3 bg-white">
                  <Breadcrumb></Breadcrumb>
                  <ListUsers
                    subfolder={props.subfolder}
                    isExecutive={true}
                    comuneDelegate={comuneDelegate}
                  ></ListUsers>
                </div>
              </Route>
              <Route exact path="/lista_utenti/nuovo_utente">
                <div className="container shadow-sm p-3 bg-white">
                  <Breadcrumb></Breadcrumb>
                  <NewUser subfolder={props.subfolder}></NewUser>
                </div>
              </Route>
              <Route exact path="/lista_utenti/dati_utente">
                <div className="container shadow-sm p-3 bg-white">
                  <Breadcrumb></Breadcrumb>
                  <EditUser subfolder={props.subfolder}></EditUser>
                </div>
              </Route>
              <Route exact path="/lista_interventi">
                <div className="container shadow-sm p-3 bg-white">
                  <Breadcrumb></Breadcrumb>
                  <ListAnnouncements
                    isExecutive={true}
                    subfolder={props.subfolder}
                  ></ListAnnouncements>
                </div>
              </Route>
              <Route exact path="/lista_utenti/cartella_sociale">
                <div className="container shadow-sm p-3 bg-white">
                  <Breadcrumb title="Dettaglio"></Breadcrumb>
                  <ViewCartellaSociale
                    isExecutive={true}
                    subfolder={props.subfolder}
                  ></ViewCartellaSociale>
                </div>
              </Route>

              <Route
                exact
                path="/lista_utenti/cartella_sociale/dettagli_iscrizione"
              >
                <div className="container mb-5 mt-3">
                  <Breadcrumb title="Dettaglio"></Breadcrumb>
                  <SubscriptionDetail
                    subfolder={props.subfolder}
                    isExecutive={true}
                  ></SubscriptionDetail>
                </div>
              </Route>
              <Route
                exact
                path={[
                  "/visualizza_isee",
                  "/lista_utenti/cartella_sociale/visualizza_isee",
                ]}
              >
                <div className="container mb-5 mt-3">
                  <Breadcrumb></Breadcrumb>
                  <ViewISEE subfolder={props.subfolder}></ViewISEE>
                </div>
              </Route>
              <Route path="*">
                <HomeExecutive subfolder={props.subfolder}></HomeExecutive>
              </Route>
            </Switch>
          )}
        </>
      ) : (
        <>
          <div className="container mb-5 mt-3">
            <Switch>
              <Route
                exact
                path={["/intervento_categoria/visualizza_categoria"]}
              >
                <Breadcrumb></Breadcrumb>
                <ViewAnnouncementsNoLogin
                  subfolder={props.subfolder}
                ></ViewAnnouncementsNoLogin>
              </Route>
              <Route path="/privacy_policy">
                <Breadcrumb></Breadcrumb>
                <PrivacyPolicy subfolder={props.subfolder}></PrivacyPolicy>
              </Route>
              <Route exact path="*">
                <HomeNoLogin subfolder={props.subfolder}></HomeNoLogin>
              </Route>
              <Route exact path="/qrcode">
                <ViewQCode subfolder={props.subfolder}></ViewQCode>
              </Route>
            </Switch>
          </div>
        </>
      )}

      {isOpen && (
        <Modal isOpen={isOpen} labelledBy="esempio1">
          <ModalHeader id="esempio1">SESSIONE SCADUTA</ModalHeader>
          <ModalBody>Esegui nuovamente il login</ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() =>
                (window.location.href = props.subfolder + "/login")
              }
            >
              Login
            </Button>
            <Button
              color="primary"
              onClick={() => (window.location.href = props.subfolder + "/home")}
            >
              Home
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </main>
  );
}

export default Body;
